import { createAction, props } from '@ngrx/store';
import { AuthRequest } from '../models/auth-request';
import { AuthResponse } from '../models/auth-response';
import { APIResponse } from 'src/app/core/models/api-response';

export const LoginAction = createAction(
  '[ Auth ] - Login',
  props<{ payload: AuthRequest; next?: string }>()
);
export const LoginActionSuccess = createAction(
  '[ Auth ] - Login Success ',
  props<{ payload: APIResponse<AuthResponse> }>()
);

export const LoginActionError = createAction('[ Auth ] - Login Error');
// loading actions
export const SetAuthLoading = createAction(
  '[ Auth ] - Set Loading',
  props<{ isLoading: boolean }>()
);
// rest pwd
export const ForgetPasswordAction = createAction(
  '[Auth] Forget Password',
  props<{ payload: { email: string; database?: string } }>()
);
export const ForgetPasswordError = createAction(
  '[Auth] Forget Password Error',
  props<{ error: string }>()
);
export const ResetPasswordAction = createAction(
  '[Auth] Reset Password',
  props<{ payload: { newPassword: string; confirm_password: string; token: string } }>()
);

export const ResetPasswordError = createAction(
  '[Auth] Reset Password Error',
  props<{ error: string }>()
);

export const UnsubscribeAction = createAction(
  '[ Auth ] - Unsubscribe',
  props<{ contact_id: number }>()
);

export const UnsubscribeActionSuccess = createAction('[ Auth ] - Unsubscribe Success ');

export const UnsubscribeActionError = createAction('[ Auth ] - Unsubscribe Error');
